import React from 'react';

const FooterLink = () => {
  const year = new Date().getFullYear();

  return (
    <div className=' mt-5 mx-2
      sm:mt-5 sm:mx-10 sm:mb-5 sm:pt-10
      md:mt-5 md:mx-20 md:mb-8 md:pt-10
      lg:mt-5 lg:mx-24 lg:mb-10 lg:pt-10 
      border-t-2 border-gray-300'
    >
      <div className='flex justify-center '>
        © Copyright {year} InFocus By <a className='text-blue-600' target='_blank' rel="noopener noreferrer" href='https://www.endataclaims.com/'>&nbsp;ENData</a>.
      </div>
    </div>
  )
}

export default FooterLink;